import React from "react";
import Form from "../../components/Form";

const LoginScreen = (props) => {
  return (
    <Form
      onRequestSend={(values) => props.auth(values)}
      isLoading={props.isLoading}
    />
  );
};

export default LoginScreen;
